import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

const typography = {
  SansSerif: 'canada-type-gibson, sans-serif',
  Serif: 'lemonde-courrier, serif',
  Condensed: 'canada-type-gibson, sans-serif',
  Display: 'lemonde-courrier, serif',
};

injectGlobal(`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${typography.SansSerif};
    color: ${colors.body};
  }

  ${
    typography.SansSerif &&
    `
      .text-sans-serif {
        font-family: ${typography.SansSerif}
      }
    `
  }

  ${
    typography.Serif &&
    `
      .text-serif {
        font-family: ${typography.Serif}
      }
    `
  }

  ${
    typography.Display &&
    `
      .text-display {
        font-family: ${typography.Display}
      }
    `
  }
  ${
    typography.Condensed &&
    `
      .text-condensed {
        font-family: ${typography.Condensed}
      }
    `
  }

  a {
    color: ${colors.brand1};
    &:hover {
      text-decoration: none;
      color: ${colors.brand1Light};
    }
  }
  p {
    font-size: 18px;
    line-height: 1.5;
    font-family: ${typography.Condensed};
    font-weight: 300;
    margin: 0 0 32px 0;
    @media (min-width: 992px) {
      font-size: 22px;
      margin: 0 0 42px 0;
    }
  }
  b, strong {
    font-weight:bold;
    font-weight:700;
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js